import { withStyles } from '@material-ui/core';
import CompletedStopStatus from './CompletedStopStatus';
import PendingStopStatus from './PendingStopStatus';
import { stopStatus } from '../../../Utils';
import DelayedStopName from './DelayedStopName';
import TrailerDropStop from './TrailerDropStop';
import { compose } from 'recompose';
import { withAppConfig } from '@appConfigContext';
import { UnarriveIndicator } from '../../../../../Dispatch/icons';
import RevisitIcon from '../../../../../Dispatch/icons/RevisitIcon';
import LateByIcon from '../../../../../Dispatch/RouteExecution/utils/DriverStatus/Icons/LateByIcon';
import StyledToolTip from '@StyledToolTip';
import { getNoFreightStatusLabel } from '../../../../../Dispatch/utils/utils';
import CustomerMergeIndicator from '../../../../../../common/CustomerMergeIndicator';
const styles = (theme) => ({
  stopName: {
    borderRadius: '4px',
    background: theme.chatBGColor,
    color: theme.TextColor,
    fontWeight: 500,
    padding: '4px 8px',
    fontSize: theme.textFontSize,
    width: '95%'
  },
  activeStop: {
    borderRadius: '4px',
    color: theme.white,
    background: theme.HeaderSelectedText,
    fontWeight: 500,
    padding: '4px 8px',
    fontSize: theme.textFontSize,
    width: '95%'
  },
  delayedStop: {
    borderRadius: '4px',
    color: theme.TextColor,
    fontWeight: 500,
    padding: '4px 8px',
    fontSize: theme.textFontSize,
    width: '95%',
    minHeight: '40px',
    alignItems: 'center',
    display: 'grid'
  },
  detailContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  stopStatus: {
    fontSize: '10px',
    fontWeight: 500,
    borderRadius: '99px',
    padding: '2px 8px',
    textTransform: 'uppercase'
  },
  stopStatusCompleted: {
    color: theme.completeStopText,
    border: `1px solid ${theme.completeStopText}`,
    background: theme.trailerBackgroundColor
  },
  stopStatusWithException: {
    color: theme.ErrorMessageColor,
    border: `1px solid ${theme.ErrorMessageColor}`,
    background: theme.statusWrapperHighlightedColor
  },
  stopStatusPending: {
    color: theme.ToggleIconColor,
    border: `1px solid ${theme.ToggleIconColor}`,
    background: theme.StatusWrapperColor
  },
  stopStatusWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  unarriveIcon: {
    display: 'flex',
    alignItems: 'center'
  },
  revisitIcon: {
    display: 'flex',
    alignItems: 'center'
  },
  otherBreakIconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 0
  }
});
const getStopStatusClass = ({ stopData, classes, hasReturnOrException }) => {
  if (stopData.isStopCompleted || stopData.isDropStop) {
    if (hasReturnOrException) {
      return classes.stopStatusWithException;
    } else {
      return classes.stopStatusCompleted;
    }
  } else {
    return classes.stopStatusPending;
  }
};

const StopName = ({
  classes,
  stopData,
  active,
  isDelayStop,
  route,
  configJSON,
  staticClientStatusLists,
  theme,
  DispatchStore
}) => {
  const { status, hasReturnOrException } = stopStatus(stopData);
  const statusClass = getStopStatusClass({ stopData, classes, hasReturnOrException });
  const iconColor = active ? theme.white : theme.TextColor;

  return isDelayStop ? (
    <DelayedStopName
      stopData={stopData}
      classes={classes}
      statusClass={statusClass}
      status={status}
    />
  ) : (
    <div className={active ? classes.activeStop : classes.stopName}>
      <div className={classes.detailContainer}>
        <div>
          {stopData.consigneeDetails?.displayCustomerName}
          <CustomerMergeIndicator
            displayCustomerName={stopData.consigneeDetails?.displayCustomerName}
            customerName={stopData.consigneeDetails?.name}
            color={iconColor}
          />
        </div>
        <div className={classes.stopStatusWrapper}>
          {stopData.unarrivedReason && (
            <UnarriveIndicator
              color={iconColor}
              size={14}
              unarrivedReason={stopData.unarrivedReason}
              className={classes.unarriveIcon}
            />
          )}
          {configJSON.enableRevisitDeliveryStop && stopData.isStopCreatedFromRevisit && (
            <StyledToolTip title="Revisit Stop">
              <div className={classes.revisitIcon}>
                <RevisitIcon color={iconColor} size={12} />
              </div>
            </StyledToolTip>
          )}

          {stopData?.delaysTakenInPNDStop?.length > 0 && (
            <StyledToolTip
              title={(stopData?.delaysTakenInPNDStop || []).join(', ')}
              placement="top">
              <span className={classes.otherBreakIconWrapper}>
                <LateByIcon
                  color={iconColor}
                  width={14}
                  height={14}
                  className={classes.otherBreakIcon}
                />
              </span>
            </StyledToolTip>
          )}
          <div className={`${classes.stopStatus} ${statusClass}`}>
            {status}{' '}
            {configJSON.enableNoFreightCode &&
              stopData.noFreightCode &&
              `(${getNoFreightStatusLabel(stopData.noFreightCode, DispatchStore?.staticClientData?.clientCodes?.noFreightCode, configJSON?.enableReturnExceptionReasonLabels)})`}
          </div>
        </div>
      </div>
      {stopData.isStopCompleted || stopData.isDropStop ? (
        <CompletedStopStatus
          stopData={stopData}
          staticClientStatusLists={staticClientStatusLists}
        />
      ) : (
        <PendingStopStatus stopData={stopData} />
      )}
      {stopData.isDropStop ? (
        <TrailerDropStop stopData={stopData} route={route} active={active} />
      ) : null}
    </div>
  );
};

export default compose(withStyles(styles, { withTheme: true }), withAppConfig)(StopName);
